import { MouseEvent } from 'react';

import { Box } from 'components/Box';
import { Button } from 'components/Button/Button';
import { SaveButton } from 'components/SaveButton';
import { ShareListingButton } from 'components/ShareListingButton';
import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown';

import { orgHasListings } from './orgHasListings';

type Props = {
  org: ApiOrg;
  isPreview: boolean;
  onClickOpportunities: (
    e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    analyticsProperties?: Record<string, unknown>,
  ) => void;
  mobile: boolean;
};

export function ViewOrgPageActionButtons({
  org,
  isPreview,
  onClickOpportunities,
  mobile,
}: Props) {
  return (
    <Box display="flex" flexWrap="wrap" position="relative">
      {orgHasListings(org) && (
        <Box m="4px">
          <Button
            type="link"
            href="#opportunities"
            variant="primary"
            onClick={(e) =>
              onClickOpportunities(e, {
                type: 'Button Top',
              })
            }
          >
            {getText('See opportunities')}
          </Button>
        </Box>
      )}
      <Box m={1}>
        <SaveButton
          disabled={isPreview}
          listingId={org.id}
          listingType={org.type}
          listingName={org.name}
        />
      </Box>
      {!mobile && (
        <Box m={1}>
          <ShareListingButton
            listingId={org.id}
            listingType="ORG"
            listingUrl={org.url}
            disabled={isPreview}
          />
        </Box>
      )}
      <Box m={1}>
        <ListingActionsDropdown
          listingId={org.id}
          listingType="ORG"
          listingUrl={org.url}
        />
      </Box>
    </Box>
  );
}
